var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"text","name":_vm.name,"id":_vm.id,"placeholder":_vm.placeholder,"readonly":""}})}
var staticRenderFns = []

export { render, staticRenderFns }